<section class="container-lg">
  <article class="row flex-row">
    <div class="col-12 col-lg-6 image-wrapper">
      @if (pressKitSection.image) {
        <mb-image [media]="pressKitSection.image"></mb-image>
      }
    </div>

    <div class="container-sm col-12 col-lg-6 content-wrapper">
      <div class="row">
        <div class="col-12 content">
          <div class="section-location-date copy-s">
            <span>{{ pressKitSection.pressKit.location }}</span>
            <span>, {{ pressKitSection.pressKit.displayDate | localizedDate: 'longDate' }}</span>
          </div>
          <h3>{{ pressKitSection.title }}</h3>
          @if (pressKitSection.pressKit.fuelLabel) {
            <div [innerHTML]="pressKitSection.pressKit.fuelLabel" class="copy-s fuel-label"></div>
          }
          <div class="copy-l content-text" [innerHTML]="pressKitSection.pressKit.content"></div>
          <button
            routerLink="{{ '/press-kit/' + pressKitSection.pressKit.id }}"
            class="btn btn-secondary btn-read-more"
          >
            {{ 'READ_MORE' | translate }}
          </button>
          <div class="section-footer">
            @if (pressKitSection.metaItems.length) {
              <ul class="meta-items">
                @for (item of pressKitSection.metaItems; track item.label) {
                  @if (item.count) {
                    <li class="meta-item">
                      {{ item.label | translate: { count: item.count } }}
                    </li>
                  }
                }
              </ul>
            }
            <mb-action-container
              [buttonItems]="defaultActions"
              [resource]="pressKitSection.pressKit"
            ></mb-action-container>
          </div>
        </div>
      </div>
    </div>
  </article>
</section>
